var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnfoldMore = function SvgUnfoldMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m3.5 11.875 1.79-1.79a.73.73 0 0 1 1.064-.002.73.73 0 0 1 .002 1.061L4.03 13.48a.7.7 0 0 1-.245.161.8.8 0 0 1-.284.047.8.8 0 0 1-.284-.047.7.7 0 0 1-.246-.161L.644 11.144a.7.7 0 0 1-.217-.53.77.77 0 0 1 .24-.53.73.73 0 0 1 1.061.001zm0-9.75-1.79 1.79a.73.73 0 0 1-1.064.002.73.73 0 0 1-.002-1.061L2.97.52A.7.7 0 0 1 3.216.36.8.8 0 0 1 3.5.313q.15 0 .284.047.132.048.245.161l2.327 2.335a.72.72 0 0 1 .227.519.72.72 0 0 1-.229.52.736.736 0 0 1-1.064 0z"
  })));
};
export default SvgUnfoldMore;